const HTTP1_TERMINATOR_ERROR =
  'Invalid HTTP/1.x request: missing "\\r\\n\\r\\n" header terminator. Add an empty line between headers and body.';
const HTTP1_PSEUDO_HEADER_ERROR =
  'Invalid HTTP/1.x request: HTTP/2 pseudo-headers (such as :authority) are not allowed. Remove them or switch the request line to HTTP/2.';
const HTTP_HEADER_FIELD_NAME_REGEX = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;
const HTTP_PSEUDO_HEADER_NAME_REGEX = /^:[a-z0-9-]+$/;

function isHttp1RequestLine(line: string): boolean {
  return /^\S+\s+\S+\s+HTTP\/1(?:\.0|\.1)?$/i.test(line.trim());
}

function looksLikeHeaderLine(line: string): boolean {
  if (line.startsWith(' ') || line.startsWith('\t')) {
    return false;
  }

  if (line.startsWith(':')) {
    const separatorIndex = line.indexOf(':', 1);
    if (separatorIndex <= 1) {
      return false;
    }
    const fieldName = line.slice(0, separatorIndex);
    return HTTP_PSEUDO_HEADER_NAME_REGEX.test(fieldName);
  }

  const separatorIndex = line.indexOf(':');
  if (separatorIndex <= 0) {
    return false;
  }

  const fieldName = line.slice(0, separatorIndex);
  return HTTP_HEADER_FIELD_NAME_REGEX.test(fieldName);
}

export function getHttp1TerminatorError({
  requestText,
}: {
  requestText: string;
}): string | null {
  const normalizedLines = requestText
    .split('\n')
    .map((line) => (line.endsWith('\r') ? line.slice(0, -1) : line));

  const requestLineIndex = normalizedLines.findIndex(
    (line) => line.trim().length > 0,
  );
  if (requestLineIndex < 0) {
    return null;
  }

  const requestLine = normalizedLines[requestLineIndex];
  if (!isHttp1RequestLine(requestLine)) {
    return null;
  }

  for (
    let lineIndex = requestLineIndex + 1;
    lineIndex < normalizedLines.length;
    lineIndex++
  ) {
    const currentLine = normalizedLines[lineIndex];
    if (currentLine.trim() === '') {
      return null;
    }
    if (!looksLikeHeaderLine(currentLine)) {
      return HTTP1_TERMINATOR_ERROR;
    }
  }

  return HTTP1_TERMINATOR_ERROR;
}

export function getHttp1PseudoHeaderError({
  requestText,
}: {
  requestText: string;
}): string | null {
  const normalizedLines = requestText
    .split('\n')
    .map((line) => (line.endsWith('\r') ? line.slice(0, -1) : line));

  const requestLineIndex = normalizedLines.findIndex(
    (line) => line.trim().length > 0,
  );
  if (requestLineIndex < 0) {
    return null;
  }

  const requestLine = normalizedLines[requestLineIndex];
  if (!isHttp1RequestLine(requestLine)) {
    return null;
  }

  for (
    let lineIndex = requestLineIndex + 1;
    lineIndex < normalizedLines.length;
    lineIndex++
  ) {
    const currentLine = normalizedLines[lineIndex];
    if (currentLine.trim() === '') {
      return null;
    }
    if (looksLikeHeaderLine(currentLine) && currentLine.startsWith(':')) {
      return HTTP1_PSEUDO_HEADER_ERROR;
    }
    if (!looksLikeHeaderLine(currentLine)) {
      return null;
    }
  }

  return null;
}
